import React from "react";
import { Menu, Button, Text, rem } from "@mantine/core";

import { ReactComponent as Ehr } from "../assets/img/Ehr.svg";
import { ReactComponent as Wear } from "../assets/img/Wear.svg";
import { ReactComponent as Arrow } from "../assets/img/Arrow.svg";
import { useNavigate } from "react-router-dom";

const MenuComponent = () => {
  const navigate = useNavigate();
  const handleClickEhr = () => {
    // Handle EHR connect click
    navigate("/admin/Integration/ehr");
  };

  const handleClickWear = () => {
    // Handle Wear Connect click
    navigate("/admin/Integration/wear");
  };

  return (
    <Menu shadow="md" width={"256px"}>
      <Menu.Target>
        <Button
          sx={{
            backgroundColor: "#1B75BC",
            width: "151px",
            height: "40px",
            padding: "9px 20px 9px 20px",
            borderRadius: "4px",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#FFFFFF",
          }}
        >
          Create App{" "}
          <span style={{ marginLeft: "16px", marginTop: "7px" }}>
            <Arrow />
          </span>
        </Button>
      </Menu.Target>

      <Menu.Dropdown
        sx={{
          position: "absolute",
          minWidth: "256px",
          right: 0,
          transform: "translateX(calc(100% - 309px))",
        }}
      >
        <Menu.Label>
          <Text
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "24px",
              color: "#262930",
              width: "268px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              padding: "8px",
            }}
          >
            Select Integration Type
          </Text>
        </Menu.Label>

        <Menu.Divider />
        <MenuItemWithIcon
          icon={<Ehr />}
          text="EHR Connect"
          onClick={handleClickEhr}
        />
        <Menu.Divider />
        <MenuItemWithIcon
          icon={<Wear />}
          text="Wear Connect"
          onClick={handleClickWear}
        />
      </Menu.Dropdown>
    </Menu>
  );
};

const MenuItemWithIcon = ({
  icon,
  text,
  onClick,
  rightSection,
  color,
}: {
  icon: React.ReactNode;
  text: string;
  onClick: () => void;
  rightSection?: React.ReactNode;
  color?: string;
}) => {
  return (
    <Menu.Item
      color={color}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "246px",
        height: "56px",
       
      }}
      onClick={onClick}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "0.5rem",
          marginLeft: "30px",
          flexWrap: "wrap",
          minWidth: "min-content",
        }}
      >
        {icon}
        <span
          style={{
            fontSize: "14px",
            color: "#474E5B",
            fontWeight: 600,
            lineHeight: "21px",
            marginLeft: "16px",
          }}
        >
          {text}
        </span>
      </div>{" "}
      {rightSection && (
        <span style={{ marginLeft: "auto" }}>{rightSection}</span>
      )}
    </Menu.Item>
  );
};

export default MenuComponent;
